import { populateQuickLinks, populateOwnedCourses, populateEnrolledCourses, populatePlanningStream,
  populateClubRecommendations, populateEventRecommendations, populateJobRecommendations, populateCompletedQuests,
  populateContinueQuestAction, getPersonProfile, getAdminReport, getRecruiterReport, getExportProspectiveStudentsToCsv,
  populatePlanningStreamWithStructure, populateStreamWithStructure, postSaveProspectiveStudentProfile, getQuestionsForGroup,
  getQuestionsForGroupAndUser, getUpgradeToEnhancedWidget, getAcceptTermsOfService, getAcceptTermsOfServiceOffline, saveUserProfileAndAnswer,
  getLearnerDashboardState, getChangeUserInstitution,getAllUserInstitution,getAllUserAccounts,getLearnerEnrollmentData,
  getNextCalendarEvent, getFeedsForStudent,getRecommendationsForStudent,getStreamLeafForCourse, getInpersonateUser,saveADASettingFlag,
  getNotificationsForStudent, getAllPurchasePrograms, getCheckTransactionValidity ,populateStreamWithStructureSummary, populateSupervisorCourses, populateSupersupervisorCourses} from '../api'

export const loadQuickLinks = ({ state, commit }, type) => {
  return populateQuickLinks(type).then(quickLinks => {
    if(type==='QUICKLINK'){
      commit('LOAD_QUICK_LINKS', quickLinks)
    }
    return quickLinks
  })
}
export const loadHandles = ({ state, commit }) => {
  return populateQuickLinks('SOCIALMEDIA').then(quickLinks => {
    return quickLinks
  })
}
export const loadPersonProfile = ({ state, commit }, userId) => {
  return getPersonProfile(userId).then(res => {
    return res
  })
}

export const loadSaveProspectiveStudentProfile = ({ state, commit }, userObj) => {
  return postSaveProspectiveStudentProfile(userObj).then(res => {
    return res
  })
}
export const saveADASetting = ({ state, commit }, userObj) => {
  return saveADASettingFlag(userObj).then(res => {
    return res
  })
}

export const loadCompletedQuests = ({ state, commit }) => {
  return populateCompletedQuests()
}

export const loadContinueQuestAction = ({ state, commit }) => {
  return populateContinueQuestAction()
}

export const loadOwnedCourses = ({ state, commit }, pagingOptions) => {
  return populateOwnedCourses(pagingOptions)
}

export const loadEnrolledCourses = ({ state, commit }, pagingOptions) => {
  return populateEnrolledCourses(pagingOptions)
}
export const loadSupervisorCourses = ({ state, commit }, pagingOptions) => {
  return populateSupervisorCourses(pagingOptions)
}
export const loadSupersupervisorCourses = ({ state, commit }, pagingOptions) => {
  return populateSupersupervisorCourses(pagingOptions)
}
export const loadPlanningStream = ({ state, commit }) => {
  return populatePlanningStream().then(data => {
    if (data !== undefined) {
      commit('LOAD_PLANNING_STREAM', data)
    }
    return data
  })
}
/*
export const loadPlanningStreamWithStructure = ({ state, commit },userId) => {
  return populatePlanningStreamWithStructure(userId).then(data => {
    if (data !== undefined) {
      commit('LOAD_PLANNING_STREAM', data)
    }
    return data
  })
}
*/
export const loadStreamWithStructure = ({ state, commit }, {programCode, userId}) => {
  return populateStreamWithStructure(programCode, userId).then(data => {
    if (data !== undefined) {
      commit('LOAD_PLANNING_STREAM', data)
    }
    return data
  })
}
export const loadStreamWithStructureSummary = ({ state, commit }, {programCode, userId}) => {
  return populateStreamWithStructureSummary(programCode, userId).then(data => {
    return data
  })
}
export const loadStreamLeafForCourse = ({ state, commit }, {programCode, originUuid}) => {
  return getStreamLeafForCourse(programCode, originUuid).then(data => {
    return data
  })
}

export const loadClubRecommendations = ({ state, commit }) => {
  return populateClubRecommendations().then(data => {
    if (data !== undefined) {
      commit('LOAD_CLUB_RECOMMENDATIONS', data)
    }
    return data
  })
}

export const loadEventRecommendations = ({ state, commit }) => {
  return populateEventRecommendations().then(data => {
    if (data !== undefined) {
      commit('LOAD_EVENT_RECOMMENDATIONS', data)
    }
    return data
  })
}

export const loadJobRecommendations = ({ state, commit }) => {
  return populateJobRecommendations().then(data => {
    if (data !== undefined) {
      commit('LOAD_JOB_RECOMMENDATIONS', data)
    }
    return data
  })
}

export const loadAdminReport = ({ state, commit }) => {
  return getAdminReport()
}

export const loadRecruiterReport = ({ state, commit }) => {
  return getRecruiterReport()
}

export const exportProspectiveStudentsToCsv = ({ state, commit }) => {
  return getExportProspectiveStudentsToCsv()
}

export const loadUpgradeToEnhancedWidget = ({ state, commit }, institutionId) => {
  return getUpgradeToEnhancedWidget(institutionId)
}

export const loadAcceptTermsOfService = ({ state, commit }, institutionId) => {
  return getAcceptTermsOfService(institutionId)
}

export const loadAcceptTermsOfServiceOffline = ({ state, commit }, institutionId) => {
  return getAcceptTermsOfServiceOffline(institutionId)
}

export const loadQuestionsForGroup = ({ state, commit }, group) => {
  return getQuestionsForGroup(group)
}

export const loadQuestionsForGroupAndUser = ({ state, commit }, {group, userId}) => {
  return getQuestionsForGroupAndUser(group, userId)
}

export const loadSaveUserProfileAndAnswer = ({ state, commit }, data) => {
  return saveUserProfileAndAnswer(data)
}

export const loadLearnerDashboardState = ({ state, commit }) => {
  return getLearnerDashboardState().then(data => {
    commit('LOAD_LEARNER_DASHBOARD_STATE', data)
    commit('LOAD_LEARNER_DASHBOARD_COMPONENTS', data.components)
    return data
  })
}
export const loadChangeUserInstitution = ({ state, commit }, institutionId) => {
  return getChangeUserInstitution(institutionId)
}
export const loadInpersonateUser = ({ state, commit }, userId) => {
  return getInpersonateUser(userId)
}

export const loadAllUserInstitution = ({ state, commit }, bringMin) => {
  return getAllUserInstitution(bringMin)
}
export const getAllUserAccountCount = ({ state, commit }) => {
  return getAllUserAccounts()
}

export const loadLearnerEnrollmentData = ({ state, commit }, userId) => {
  return getLearnerEnrollmentData(userId).then(data => {
    commit('LOAD_LEARNER_ENROLLMENT_DATA', data)
    return data
  })
}

export const loadGetNextCalendarEvent = ({ state, commit }) => {
  return getNextCalendarEvent()
}
export const loadFeedsForStudent= ({ state, commit }) => {
  return getFeedsForStudent()
}

export const loadRecommendationsForStudent = ({ state, commit }) => {
  return getRecommendationsForStudent()
}

export const loadNotificationsForStudent = ({ state, commit }) => {
  return getNotificationsForStudent()
}

export const loadCheckTransactionValidity = ({ state, commit }, programId) => {
  return getCheckTransactionValidity(programId)
}
export const loadAllPurchasePrograms = ({ state, commit }) => {
  return getAllPurchasePrograms()
}

export const loadCheckSubscriptionValidity = ({ state, commit }, programId) => {
  return getCheckSubscriptionValidity(programId)
}



// WEBPACK FOOTER //
// ./src/app/dashboard/vuex/actions.js